import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message", "bar"]
  static values = { url: String }

  connect() {
    this.startProgress()
    this.scheduleRedirect()
  }

  startProgress() {
    const messages = [
      "Setting up your site...",
      "Configuring booking system...",
      "Applying your brand...",
      "Almost ready..."
    ]
    
    let step = 0
    this.progressInterval = setInterval(() => {
      step++
      const progress = Math.min(step * 25, 100)
      this.barTarget.style.width = `${progress}%`
      
      if (messages[step - 1]) {
        this.messageTarget.textContent = messages[step - 1]
      }
      
      if (progress >= 100) {
        clearInterval(this.progressInterval)
      }
    }, 600)
  }

  scheduleRedirect() {
    this.redirectTimer = setTimeout(() => {
      window.location.href = this.urlValue
    }, 3000)
  }

  disconnect() {
    clearInterval(this.progressInterval)
    clearTimeout(this.redirectTimer)
  }
}